import React from 'react'

function SvgRdv() {
  return (
    <svg
    className="menu-icon"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.95833 7.92855H15.625M5.46627 3V4.28586M13.9583 3V4.28571M16.4583 6.53571V15.75C16.4583 16.9926 15.4634 18 14.2361 18H5.34722C4.11992 18 3.125 16.9926 3.125 15.75V6.53571C3.125 5.29307 4.11992 4.28571 5.34722 4.28571H14.2361C15.4634 4.28571 16.4583 5.29307 16.4583 6.53571Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  )
}

export default SvgRdv